module.exports = __webpack_public_path__ + "static/media/kali_puja.e866926e.jpeg";